import { useEffect, useState, useContext } from "react";
import { api } from "../utils/api";

const usePushNotifications = ({ jwtToken, currentGroupId, setDeviceToken }) => {
  const [_pushLog, setPushLog] = useState("");
  const [iOSPushCapability, setIOSPushCapability] = useState(false);

  const logMessage = (message) => {
    let toConsole = message;
    try {
      toConsole = JSON.parse(message);
    } catch (_) {}
    console.log(toConsole);
    setPushLog((prev) => `${prev}>: ${message}\r\n`);
  };

  const pushTokenRequest = () => {
    window.webkit.messageHandlers["push-token"].postMessage("push-token");
  };

  const savePushToken = async (customEvent) => {
    try {
      const { data } = await api.addDevice({
        device: {
          fcm_token: customEvent.detail,
          platform: "ios",
        },
      });
      setDeviceToken(data);
    } catch (error) {
      console.error("Error saving FCM token:", error);
    }
  };

  useEffect(() => {
    const logEvent = (event) => {
      if (event && event.detail) {
        logMessage(
          typeof event.detail === "string"
            ? event.detail
            : JSON.stringify(event.detail)
        );
      }
    };

    window.addEventListener("push-permission-request", logEvent);
    window.addEventListener("push-permission-state", logEvent);
    window.addEventListener("push-notification", logEvent);
    window.addEventListener("push-notification-click", logEvent);
    window.addEventListener("push-token", savePushToken);

    if (
      jwtToken &&
      currentGroupId &&
      window.webkit &&
      window.webkit.messageHandlers
    ) {
      setIOSPushCapability(true);
    }

    return () => {
      window.removeEventListener("push-permission-request", logEvent);
      window.removeEventListener("push-permission-state", logEvent);
      window.removeEventListener("push-notification", logEvent);
      window.removeEventListener("push-notification-click", logEvent);
      window.removeEventListener("push-token", logEvent);
    };
  }, [jwtToken]);

  useEffect(() => {
    if (iOSPushCapability) {
      pushTokenRequest();
    }
  }, [iOSPushCapability]);
};

export default usePushNotifications;
